import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();
  private count = 0;

  show(): void {
    this.count++;
    this._loading.next(true);
  }

  hide(): void {
    this.count--;
    if (this.count === 0) {
      this._loading.next(false);
    }
  }

  setLoading(status: boolean) {
    this._loading.next(status);
  }
}
